var App = App || {};

App.WidgetCards = (function ($) {
    'use strict';

    function Init(widget) {
        const animate = widget.find(".widget-cards__cards");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".partial-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);